const currencyFormat = (amount, showDecimalPlaces = false) =>
  new Intl.NumberFormat('en-US', {
    currency: 'USD',
    minimumFractionDigits: amount ? (showDecimalPlaces ? undefined : 0) : 0,
    style: 'currency'
  }).format(!showDecimalPlaces ? Math.round(amount) : amount)

export { currencyFormat }
